import { render, staticRenderFns } from "./addSsy.vue?vue&type=template&id=09984158&scoped=true&"
import script from "./addSsy.vue?vue&type=script&lang=js&"
export * from "./addSsy.vue?vue&type=script&lang=js&"
import style0 from "./addSsy.vue?vue&type=style&index=0&id=09984158&prod&scoped=true&lang=css&"
import style1 from "./addSsy.vue?vue&type=style&index=1&id=09984158&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09984158",
  null
  
)

export default component.exports